import * as React from "react";
import { CreateOrEditWorkerSettingsPage } from "./CreateOrEditWorkerSettingsPage";
interface WorkerPageProps {
    spaceId: string;
    machineId: string;
}
export function WorkerSettingsPage({ spaceId, machineId }: WorkerPageProps) {
    return <CreateOrEditWorkerSettingsPage spaceId={spaceId} machineId={machineId}/>;
}
